import Loadable from 'react-loadable';

import AsyncLoading from '@dragonfruit/components/AsyncLoading';

const LoadableDeleteAccountReason = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteAccountReason" */ './DeleteAccountReason.jsx'
    ),
  loading: AsyncLoading,
});

export default LoadableDeleteAccountReason;



// WEBPACK FOOTER //
// ./app/containers/DeleteAccountReason/LoadableDeleteAccountReason.js